(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.desktopSearchTrigger = this.querySelector('.desktop-search--link');
      if (this.desktopSearchTrigger != null) {
        this.desktopSearchTrigger.addEventListener('click', this.onDesktopSearchTriggerClick.bind(this));
      }
    }

    onDesktopSearchTriggerClick(e) {
      e.preventDefault();

      const searchTrigger = e.target;
      const searchInput = searchTrigger.nextElementSibling;
      const searchBtn = searchInput.nextElementSibling;

      searchTrigger.style.display = 'none';
      searchInput.style.display = 'block';
      searchBtn.style.display = 'block';
      searchInput.focus();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const header = this.querySelector('header');
      const headerWrapper = header.querySelector('.header--wrapper');
      const headerMenu = this.querySelector('.header__inline-menu');

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      if (headerMenu) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          headerMenu.classList.add('header__inline-menu--hidden');
          headerWrapper.classList.add('header--sticky');
        } else if (scrollTop < this.currentScrollTop - 5) {
          headerMenu.classList.remove('header__inline-menu--hidden');
          headerWrapper.classList.remove('header--sticky');
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.desktopSearchTrigger = this.querySelector('.desktop-search--link');
      if (this.desktopSearchTrigger) {
        this.desktopSearchTrigger.addEventListener('click', this.onDesktopSearchTriggerClick.bind(this));
      }
    }

    onDesktopSearchTriggerClick(e) {
      e.preventDefault();
      const searchTrigger = e.target;
      const searchInput = searchTrigger.nextElementSibling;
      const searchBtn = searchInput?.nextElementSibling;

      searchTrigger.style.display = 'none';
      if (searchInput) {
        searchInput.style.display = 'block';
        searchInput.focus();
      }
      if (searchBtn) {
        searchBtn.style.display = 'block';
      }
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.dataset.alwaysSticky = 'true';
      }

      if (window.HeaderScrollHandler) {
        this.headerScrollHandler = new window.HeaderScrollHandler(this.header);
      }
    }

    disconnectedCallback() {
      if (this.headerScrollHandler) {
        this.headerScrollHandler.destroy();
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
